import { Box } from '@chakra-ui/react'
import EventHighlightsTable from './components/EventHighlightsTable'

export default function EventHighlightsView() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <EventHighlightsTable />
    </Box>
  )
}
